import { readPackageJson, writePackageJson } from '@wix/cli-fs';
import { addMissingDependencies } from './add-missing-dependencies.js';
import { modifyAstroConfig } from './modify-astro-config.js';
import { setScripts } from './set-scripts.js';

export async function extend(projectFolder: string) {
  const packageJson = await readPackageJson(projectFolder);

  addMissingDependencies(packageJson, {
    dependencies: {
      '@wix/sdk': '^1.15.23',
      '@wix/essentials': '^0.1.23',
      '@wix/dashboard': '^1.3.43',
    },
    devDependencies: {
      '@astrojs/cloudflare': '^12.5.3',
      '@astrojs/react': '^4.3.0',
      '@types/react': '^18.3.1',
      '@types/react-dom': '^18.3.1',
      '@wix/cli': '^1.1.92',
      '@wix/astro': '^2.38.0',
      react: '18.3.1',
      'react-dom': '18.3.1',
      '@wix/cloud-provider-fetch-adapter': '^1.0.0',
    },
  });

  setScripts(packageJson, {
    astro: 'astro',
    wix: 'wix',
    dev: 'wix dev',
    build: 'wix build',
    preview: 'wix preview',
    release: 'wix release',
    generate: 'wix generate',
    env: 'wix env',
    skills: 'wix skills',
  });

  await writePackageJson(projectFolder, packageJson);

  await modifyAstroConfig(projectFolder);
}
